function normalizeUrl(value) {
  return String(value || "").trim().replace(/\/+$/, "");
}

export function getLeadEndpoint() {
  const config = typeof window !== "undefined" ? window.APP_CONFIG || {} : {};
  const apiBaseUrl = normalizeUrl(config.apiBaseUrl);
  const leadsEndpoint = normalizeUrl(config.leadsEndpoint);

  if (leadsEndpoint) return leadsEndpoint;
  if (apiBaseUrl) return `${apiBaseUrl}/api/contact-lead`;
  return "/api/contact-lead";
}
